import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllServices } from 'store/Contextualization/AssetDetail/actions';
import Checkbox from 'Common/Components/Checkbox';
import { allServicesAreSelected, someServiceIsSelected } from 'store/Contextualization/AssetDetail/selectors';

export const CheckHeader = () => { // eslint-disable-line import/prefer-default-export
  const allServiceSelected = useSelector(allServicesAreSelected);
  const someServiceSelected = useSelector(someServiceIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllServices());
  };

  return (
    <Checkbox theme="grey" onChange={ handleClick } state={ allServiceSelected } partialChecked={ someServiceSelected && !allServiceSelected } />
  );
};
